import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const TabNavigation = ({ activeTab, onTabChange }) => {
  const location = useLocation();
  const { user } = useAuth();

  const allTabs = [
    { id: 'home', label: 'Home', path: '/', requiresAuth: false },
    { id: 'how-it-works', label: 'How It Works', path: '/how-it-works', requiresAuth: false, hideWhenLoggedIn: true },
    { id: 'news', label: 'News Feeds', path: '/news', requiresAuth: true },
    { id: 'social', label: 'Social Feeds', path: '/social', requiresAuth: true },
    { id: 'bull-pin', label: 'Bull Pen', path: '/bull-pin', requiresAuth: true, isSpecial: true },
    { id: 'bear-den', label: 'Bear Den', path: '/bear-den', requiresAuth: true, isSpecial: true }
  ];

  // Filter tabs based on authentication status and hide rules
  const tabs = allTabs.filter(tab => {
    // Show if it doesn't require auth OR user is logged in
    const authCheck = !tab.requiresAuth || user;
    // Hide if it should be hidden when logged in AND user is logged in
    const hideCheck = !(tab.hideWhenLoggedIn && user);
    return authCheck && hideCheck;
  });

  const getCurrentTab = () => {
    const currentPath = location.pathname;
    return tabs.find(tab => tab.path === currentPath)?.id || 'home';
  };

  return (
    <nav className="tab-navigation">
      <ul className="tab-list">
        {tabs.map(tab => (
          <li key={tab.id} className="tab-item">
            <Link
              to={tab.path}
              className={`tab-link ${getCurrentTab() === tab.id ? 'active' : ''} ${tab.isSpecial ? 'special-tab' : ''}`}
              onClick={() => onTabChange && onTabChange(tab.id)}
            >
              {tab.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TabNavigation;